import tinymce from './src/tinymce';

if (typeof roleDescriptionReadable !== 'undefined') {
    if (roleDescriptionReadable) {
        tinymce.init({
            selector             : '.view.form_page_section_field.text_editor textarea',
            height               : '170',
            menubar              : false,
            statusbar            : false,
            toolbar              : false,
            nonbreaking_force_tab: false,
            readonly             : true,
        });
    }
} else {
    tinymce.init({
        selector             : '.view.form_page_section_field.text_editor textarea',
        plugins              : ["advlist", "anchor", "autoresize", "charmap", "code", "image", "link", "lists", "nonbreaking", "searchreplace", "table"],
        toolbar1             : 'bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | outdent indent | bullist numlist',
        toolbar2             : 'styles | fontfamily | fontsize | forecolor backcolor',
        toolbar3             : 'undo redo | anchor link | hr nonbreaking | charmap | image | subscript superscript | code',
        image_advtab         : true,
        images_upload_url    : '/api/integrations/tinymce/upload-image',
        menubar              : false,
        nonbreaking_force_tab: true,
        relative_urls        : false,
        convert_urls         : false,
        remove_script_host   : false,
        paste_preprocess     : function (plugin, args) {
            var content  = args.content;
            content      = content.replace(/`/g, '\'');
            content      = content.replace(/[\u2018\u2019\u00B4]/g, '\'');
            content      = content.replace(/[\u201E\u201C\u201D]/g, '"');
            content      = content.replace(/\u201A/g, ',');
            content      = content.replace(/\u02C6/g, '^');
            content      = content.replace(/\u2039/g, '<');
            content      = content.replace(/\u203A/g, '>');
            content      = content.replace(/\u2020/g, '+');
            content      = content.replace(/\u2021/g, '+');
            content      = content.replace(/[\u2013\u2014\u00AF]/g, '-');
            content      = content.replace(/\u02DC/g, '~');
            content      = content.replace(/\u2026/g, '...');
            content      = content.replace(/\u2022/g, '*');
            content      = content.replace(/\u00A4/g, '*');
            content      = content.replace(/\u00A6/g, '|');
            content      = content.replace(/\u00A8/g, '"');
            content      = content.replace(/\u00D7/g, 'x');
            content      = content.replace(/\u00F7/g, '/');
            content      = content.replace(/\u00AB/g, '<<');
            content      = content.replace(/\u00BB/g, '>>');
            args.content = content;
        }
    });
}

// full width to select section of application forms only
$(function () {
    $('form[action*="/applications/"] select.form-control').parents('.form_page_section_field').css('width', '100%');
});